import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { $Elements, Animations, Classes, Events } from '../global/constants';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: (this.classList.contains('parallax-header')) ? 'top top' : 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => (this.classList.contains('parallax-header')) ? 0 : offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);

				return timeline;
			}
			return null;
		});
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			return ScrollTrigger.create({
				trigger: this,
				once: true,
				start: 'top 80%',
				end: 'top 40%',
				toggleClass: Classes.active,
			});
		});
	});

	// ---------- Animated Section ----------
	$('.single-vin .content-section:first-child').each(function() {
		const section = this;

		Animations.global.push(() => {
			const packshotImg = section.querySelector('.packshot-column img, .packshot-column .image');
			const addShow = () => section.classList.add(Classes.show);

			const waitForImageThenShow = () => {
				if(!packshotImg) return addShow();

				if(packshotImg.tagName === 'IMG') {
					if(packshotImg.complete && packshotImg.naturalWidth > 0) return addShow();
					packshotImg.addEventListener('load', addShow, { once: true });
					packshotImg.addEventListener('error', addShow, { once: true });
					return;
				}
				addShow();
			};

			return ScrollTrigger.create({
				trigger: section,
				start: 'top 80%',
				once: true,
				onEnter: waitForImageThenShow,
			});
		});
	});


	// ---------- Animated Header Home page Section ----------

	$('.home').each(function() {
		const section = this.querySelector('.hero-section');
		const headerWrapper = this.querySelector('.header-wrapper-home');
		if(!section || !headerWrapper) return;


		Animations.global.push(() => {

			return ScrollTrigger.create({
				trigger: section,
				start: 'bottom top',
				onEnter: () => headerWrapper.classList.add(Classes.show),
				onLeaveBack: () => headerWrapper.classList.remove(Classes.show),
				invalidateOnRefresh: true,
			});
		});
	});

	// ---------- Animated Experiences Section ----------

	$('.experiences-section').each(function() {

		Animations.global.push(() => {

			return ScrollTrigger.create({
				trigger: this,
				start: 'center 65%',
				toggleClass: Classes.show,
			});
		});
	});

	// ---------- Animated Image ----------

	$('.image-double-texte-section .section-columns, .text-image-destructuree-section .section-columns').each(function() {
		const section = this;

		const target = section.querySelector('.image-column .column-image');
		if(!target) return;

		if(target.querySelector('.video')) return;

		const factor = section.closest('.text-image-destructuree-section') ? 0.08 : 0.2;

		Animations.mobile.min.push(() => {
			const getY = () => {
				const vh = window.innerHeight || 800;
				const y = vh * factor;
				return -Math.round(Math.min(140, Math.max(40, y)));
			};

			return gsap.fromTo(
				target,
				{ y: 0 },
				{
					y: getY,
					ease: 'none',
					scrollTrigger: {
						trigger: section,
						start: 'top bottom',
						end: 'bottom top',
						scrub: 1.2,
						invalidateOnRefresh: true,
						fastScrollEnd: true,
					}
				}
			);
		});
	});

	// ---------- Menu ----------

	$Elements.HeaderWrapper.each(function() {
		const header = this;

		Animations.global.push(() => {

			return ScrollTrigger.create({
				start: 1,
				end: 'max',
				onUpdate: (self) => {
					(self.direction === -1) ? header.classList.remove(Classes.shrink) : header.classList.add(Classes.shrink);
					(self.progress > 0) ? header.classList.add(Classes.shrinkable) : header.classList.remove(Classes.shrinkable);
				}
			});
		});
	});

};


$Elements.document.on(Events.page.enter, () => initScrollAnimations());
